import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class ReportService {
  baseHref = `${environment.apiUrl}/reports`;

  constructor(private http: HttpClient) {}

  reportUser(data: {
    message: string;
    reason: string;
    type: string;
    targetId: number;
    itemId?: number;
  }): Observable<any> {
    const url = `${this.baseHref}`;
    return this.http.post<any>(url, data);
  }
}
